import { POST } from "../../index";

export const queryContractList = (param) => POST("/v1/CostContractController/queryList", param);
export const insertContract = (param) => POST("/v1/CostContractController/insert", param);
export const deleteContract = (param) => POST("/v1/CostContractController/delete", param);
